// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3DQ0u","bigColWidth":"Table_bigColWidth__1vdru","biggerColWidth":"Table_biggerColWidth__1_4tN","row":"Table_row__Adcqz","col":"Table_col__1X_gU"};